
import React from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CheckCircle, Bell, HelpCircle, MessageCircle } from "lucide-react";

interface SupportMessagesProps {
  isPremium: boolean;
}

const SupportMessages: React.FC<SupportMessagesProps> = ({ isPremium }) => {
  const messages = [
    {
      id: 1,
      type: "tip",
      title: "Complete your profile",
      message: "Add at least 3 images to your gallery to boost your listing's appeal."
    },
    {
      id: 2,
      type: "notification",
      title: "New feature available",
      message: "You can now add custom tags to your listing to attract more visitors."
    },
    {
      id: 3,
      type: "update",
      title: "System update",
      message: "Our platform was updated with new analytics features for Premium users."
    }
  ];

  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle>Support & Updates</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-4">
          {messages.map((message) => (
            <div 
              key={message.id}
              className={`p-4 rounded-md border ${
                message.type === 'tip' 
                  ? 'bg-blue-50 border-blue-100' 
                  : message.type === 'notification'
                    ? 'bg-orange-50 border-orange-100' 
                    : 'bg-gray-50 border-gray-200'
              }`}
            >
              <div className="flex items-start gap-3">
                <div className={`p-2 rounded-full ${
                  message.type === 'tip' 
                    ? 'bg-blue-100' 
                    : message.type === 'notification'
                      ? 'bg-orange-100' 
                      : 'bg-gray-100'
                }`}>
                  {message.type === 'tip' ? (
                    <HelpCircle size={16} className="text-blue-600" />
                  ) : message.type === 'notification' ? (
                    <Bell size={16} className="text-orange-600" />
                  ) : (
                    <CheckCircle size={16} className="text-gray-600" />
                  )}
                </div>
                <div className="flex-1">
                  <h4 className="text-sm font-medium mb-1">{message.title}</h4>
                  <p className="text-xs text-gray-600">{message.message}</p>
                </div>
              </div>
            </div>
          ))}
          
          <div className="mt-4 pt-4 border-t border-gray-100 flex justify-between items-center">
            <div className="flex items-center text-sm text-gray-600">
              <MessageCircle size={16} className="mr-2" />
              <span>Need help with your listing?</span>
            </div>
            <Button variant="outline" size="sm" className="text-sauna-blue">
              Contact Support
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default SupportMessages;
